@if (isDealer || lpDealerId || isConsultant || isSeller || isVE) {
	<div class="d-none d-sm-block" [ngClass]="{ 'sticky-top': fixedHeader, 'top-0': !fixedHeader }" id="sites-bar">
		<div class="container-fluid">
			<div class="row">
				@if (isDealer && !lpDealerId) {
					<div class="col-12 dealer-col">
						<div class="dealer-title">Portal Dealer</div>
					</div>
				}
				@if (lpDealerId) {
					<div class="col-12 dealer-col">
						<div class="dealer-title">{{ lpDealerData?.name }}</div>
					</div>
				}
				@if (isSeller && !isDealer && !isVE) {
					<div class="col-12 dealer-col">
						<div class="dealer-title">{{ textHeader.assistedSalesPortal }}</div>
					</div>
				}
				@if (isVE && !isDealer && !isSeller) {
					<div class="col-12 dealer-col">
						<div class="dealer-title">{{ textHeader.assistedSalesPortalVE }}</div>
					</div>
				}
				<!-- <div *ngIf="!isSeller && !isVE && !isDealer" class="col-12 dealer-col">
        <div class="dealer-title">{{ textHeader.assistedSalesPortalKA }}</div>
      </div> -->
				@if (!isDealer && !isVE && isConsultant) {
					<div class="col-12 dealer-col">
						<div class="dealer-title">{{ textHeader.consultantPortal }}</div>
					</div>
				}
			</div>
		</div>
	</div>
}

<nav class="navbar navbar-expand-lg navbar-light bg-light" [ngClass]="{ opened: openNav, 'sticky-top': fixedHeader, 'top-0': !fixedHeader, mobilizesLogo: mobilizesLogo }">
	<div class="container-fluid navbar-content">
		<a [routerLink]="[isSeller || isVE ? '/concessionarias/propuestas' : this.isConsultant ? '/consultor' : user && user?.authContext?.dealershipId ? '/concessionarias' : '']" (click)="emitEvent('home')" aria-label="Home Renault Renting" class="navbar-brand logo">
			@if (!isSeller && !isVE) {
				<img [width]="mobilizesLogo ? '180' : '50'" height="50" [src]="mobilizesLogo ? '/assets/images/mobilize-logo.svg' : '/assets/images/logo-nav.svg'" alt="" loading="lazy" />
			}
			@if ((!openNav && isSeller) || isVE) {
				<img height="50" [src]="'/assets/images/mobilize-logo-venta.png'" alt="" style="margin-right: -40px" loading="lazy" />
			}
		</a>
		<button (click)="toggleNav()" class="hamburger hamburger--elastic hamburger--collapse" type="button" aria-label="Abrir Menu" [ngClass]="{ 'is-active': openNav }">
			<span class="hamburger-box">
				<span class="hamburger-inner"></span>
			</span>
		</button>
		@if (!isLoading) {
			<div class="collapse navbar-collapse" [ngClass]="{ collapse: !openNav }" id="navbarSupportedContent">
				@if (!user || !user?.authContext?.dealershipId) {
					<ul class="site-nav navbar-nav me-auto d-flex justify-content-center">
						@if (!isConsultant && !isSeller && !isVE) {
							<li class="nav-item">
								<a class="nav-link" (click)="emitEvent('como-funciona-renta-renault')" [routerLink]="['/institucional/como-funciona-renta-renault']">{{ textHeader.howDoesItWork }}</a>
							</li>
						}
						@if (!isConsultant && !isSeller && !isVE) {
							<li class="nav-item">
								<a class="nav-link" (click)="emitEvent('faq-renta-de-carros')" [routerLink]="['/institucional/faq-renta-de-carros']">{{ textHeader.doubts }}</a>
							</li>
						}
						@if (!isConsultant && !isSeller && !isVE) {
							<li class="nav-item">
								<a class="nav-link" (click)="emitEvent('para-empresas')" [routerLink]="['/institucional/alquiler-de-carro-empresas']">{{ textHeader.forBusiness }}</a>
							</li>
						}
						@if (lpDealerId) {
							<li class="nav-item">
								<a class="nav-link" (click)="emitEvent('para-empresas')" [routerLink]="['/institucional/nossas-lojas']">{{ textHeader.ourStores }}</a>
							</li>
						}
						@if (!isConsultant && !isSeller && !isVE && !isKA) {
							<li class="nav-item">
								<a class="nav-link" data-cy="header-simulate-now" (click)="emitEventSimulation('simule-agora')" [routerLink]="[isSeller || isVE ? '/concessionarias/seller' : '/simulador/renta-mensual-de-un-vehiculo']">{{ textHeader.simulateNow }}</a>
							</li>
						}
						@if (!isConsultant && !isSeller && !isVE) {
							<li class="nav-item">
								<a class="nav-link" data-cy="header-simulate-now" (click)="emitEventSimulation('solicitar-acessoria')" [routerLink]="['/institucional/asesoria']">{{ textHeader.contactUs }}</a>
							</li>
						}
						@if (isConsultant) {
							<li class="simulation-button ms-0 me-5 pe-4">
								<a class="nav-link" data-cy="header-consult" (click)="emitEventSimulation('consultor')" [routerLink]="['/consultor']">{{ textHeader.consultantsArea }}</a>
							</li>
						}
					</ul>
				}
				@if (user && (user?.authContext?.dealershipId || isSeller || isVE)) {
					<ul class="site-nav navbar-nav me-auto d-flex justify-content-center" [ngClass]="{ 'dealer-nav': user?.authContext?.dealershipId }">
						<li class="nav-item">
							<a class="nav-link" href="#" (click)="$event.preventDefault(); goToMyProposals($event)">{{ textHeader.myProposals }}</a>
						</li>
						@if (isSeller) {
							<li class="nav-item">
								<a class="nav-link" href="#" (click)="$event.preventDefault(); generateLinkVendaAssistida()">{{ textHeader.generateAssistedSalesLink }}</a>
							</li>
						} @else {
							<li class="nav-item">
								<a class="nav-link" [routerLink]="['/concessionarias/gerar-link']">{{ textHeader.generatePortLink }}</a>
							</li>
						}
						@if (!isKA) {
							<li class="simulation-button">
								<a class="nav-link" [routerLink]="[isSeller || isVE ? '/concessionarias/seller' : '/concessionarias']">{{ textHeader.simulateNow }}</a>
							</li>
						}
						@if (isVE || isDealer || isSeller) {
							<li class="simulation-button">
								@if (isVE) {
									<a class="nav-link" [routerLink]="['/concessionarias/prospecto']">{{ textHeader.generateProposal }}</a>
								}
								@if (isDealer || isSeller) {
									<a class="nav-link" [routerLink]="['/concessionarias/client-type-form']">{{ textHeader.generateProposal }}</a>
								}
							</li>
						}
						@if (isVE && hasAssociatedClients) {
							<li class="simulation-button">
								<a class="nav-link" href="#" (click)="openClientsPortal($event)">{{ textHeader.clients }}</a>
							</li>
						}
					</ul>
				}
				<div class="user-menu">
					@if ((!user || !user?.authContext?.dealershipId) && !isConsultant && !isSeller && !isVE) {
						<div class="item" (click)="emitEvent('mi-carrito')" [routerLink]="['/simulador/carrito']">
							<div class="icon">
								<img src="/assets/icons/svg/cart.svg" alt="Meu carrito" style="margin-top: -2px" loading="lazy" />
								<div class="basket-length">
									{{ session.length }}
								</div>
							</div>
							<div class="label">
								<a (click)="emitEvent('mi-carrito')" [routerLink]="['/simulador/carrito']"> {{ textHeader.my }} {{ textHeader.cart }} </a>
							</div>
						</div>
					}
					@if (!user || !user?.authContext?.dealershipId) {
						<div class="item" [routerLink]="[this.isSeller || this.isVE ? '/concessionarias/seller' : this.isConsultant ? '/consultor' : '/area-logada']">
							<div class="icon">
								<img src="/assets/icons/svg/user.svg" alt="Login/Novo Cadastro" loading="lazy" />
							</div>
							<div class="label">
								@if (!user) {
									<a (click)="emitEvent('login/novo-cadastro')" [routerLink]="['/conta/login']">{{ textHeader.sigin }}/{{ textHeader.signup }}</a>
								}
								@if (user && loggedUser) {
									<a [routerLink]="['/']">{{ displayedUserName }}</a>
									<ng-container>
										<br />
										<a class="sign-out" href="#" (click)="$event.preventDefault(); logOut()">{{ textHeader.signout }}</a>
									</ng-container>
								}
							</div>
						</div>
					}
					@if (user && user?.authContext?.dealershipId) {
						<div class="item" [routerLink]="['/concessionarias']">
							<div class="icon">
								<img src="/assets/icons/svg/user.svg" alt="Login/Novo Cadastro" loading="lazy" />
							</div>
							<div class="label">
								<a>{{ textHeader.welcome }}, {{ dealerInfos?.name }}</a
								><br />
								<a href="#" (click)="$event.preventDefault(); logOut()">{{ textHeader.signout }}</a>
							</div>
						</div>
					}
				</div>
			</div>
		}
	</div>
</nav>
